import React from "react";
import LoginView from "../views/LoginView";
import LoginViewStore from "../../stores/LoginViewStore";
import EventPublisher from "../../utils/EventPublisher";
import StoreUpdateEvents from "../../constants/events/StoreUpdateEvents";
import LoadingStates from "../../constants/states/LoadingStates";

class LoginContainer extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            "loginViewState": LoginViewStore.getState()
        }
    }

    componentDidMount() {
        this.loginViewStoreSubscriber =
            EventPublisher.subscribe(StoreUpdateEvents.LOGIN_VIEW_STORE_UPDATED, this.handleStoreUpdate);
    }

    componentWillUnmount() {
        EventPublisher.unsubscribe(this.loginViewStoreSubscriber);
    }

    handleStoreUpdate = (topic, data) => {
        this.setState({
            "loginViewState": LoginViewStore.getState()
        });
    };

    render() {
        return (
            <LoginView
                isLoggingIn={this.state.loginViewState.loadingState === LoadingStates.LOADING}
                isFailed={this.state.loginViewState.loadingState === LoadingStates.FAILED_TO_LOAD}
            />
        );
    }
}

export default LoginContainer;